<template>
	<div class="hello">
		<div class="tips">！温馨提示：“首次预约，请先注册”</div>
		<div class="logo">
			<img src="../assets/logo.png" />
		</div>
		<div class="logo_option">
			<p>团队登录</p>
			<div class="IDNumber">
				<img src="../assets/landpeople.png" />
				<input @focus="getFocus" ref="inputFocus" v-model="IDNumber" type="" name="IDNumber" id="IDNumber" value="" placeholder="请输入用户名" />
			</div>
			<div class="password">
				<img src="../assets/landpass.png" />
				<input @focus="getFocus" ref="inputFocus" v-model="pass" type="password" name="password" id="password" value="" placeholder="请输入密码" />
			</div>
			<div class="land_text">
				<div @click="GroupRegistration">团队注册</div>
				<div @click="ForgetPassword">忘记密码?</div>
			</div>
			<div class="land_btn" @click="landBtn">登录</div>
		</div>
		<div class="appointment_success" v-show="success">
			<div class="success_center">
				<img v-if="success_img" src="../assets/success.png" />
				<img v-if="!success_img" src="../assets/buttom_x.png" />
				<p>{{success_text}}</p>
				<div @click="determine">确定</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { wclient } from '../../static/wclient-mobile.js'
	export default {
		name: 'Land',
		data() {
			return {
				IDNumber: "",
				pass: "",
				baseUrl: "",
				success: false,
				success_img: false,
				success_text: ""
			}
		},
		methods: {
			getFocus() {    
				$("input").on("blur", function() {        
					window.scroll(0, 0);    
				});
			},
			landBtn() {
				var that = this;
				if(that.IDNumber == '') {
					that.success = true;
					that.success_img = false;
					that.success_text = '请输入用户名、密码'
				} else {
					$.ajax({
						type: "post",
						url: that.baseUrl + "/tickets/tickets/ajax?ugi=loginUgi&action=teamLogin",
						async: true,
						data: {
							accountName: that.IDNumber,
							password: that.pass,
							type:0
						},
						dataType: 'jsonp',
						crossDomain: true,
						xhrFields: {
							withCredentials: true
						},
						success: function(res) {
							if(res.code == 'A00006') {
								sessionStorage.setItem("RegistrantName", res.teamAccount.realname);
								sessionStorage.setItem("RegistrantIdNumber", res.teamAccount.idnumber);
								sessionStorage.setItem("RegistrantPhone", res.teamAccount.phone);
								sessionStorage.setItem("RegistrantTeamname", res.teamAccount.teamname);
								if(res.teamAccount.teamtype != '5') {
									that.$router.push({
										name: 'TeamReservation'
									});
								} else {
									that.success = true;
									that.success_img = false;
									that.success_text = "请输入非旅行社账号"
								}
							} else if(res.code == 'A00001') {
								that.success = true;
								that.success_img = false;
								that.success_text = '系统繁忙，请稍后再试'
							} else {
								that.success = true;
								that.success_img = false;
								that.success_text = res.errmsg
							}
						}
					});
				}
			},
			GroupRegistration() {
				var that = this;
				that.$router.push({
					name: 'GroupRegistration'
				});
			},
			ForgetPassword() {
				var that = this;
				sessionStorage.setItem('pass', 'team')
				that.$router.push({
					name: 'ForgetPassword'
				});
			},
			determine() {
				var that = this;
				if(that.success_text == "登录成功") {
					that.$router.push({
						name: 'Personal'
					});
				} else {
					that.success = false;
				}
			}
		},
		mounted() {
			var that = this;
			var publicUrl = window.location.hostname;
			if(publicUrl == "localhost") {
				var baseUrl = "https://www.xiangshan1949.cn";
			} else if(publicUrl == "m.xs.weapi.org") {
				var baseUrl = "https://www.xiangshan1949.cn";
			} else {
				var baseUrl = "https://www.xiangshan1949.cn";
			}
			that.baseUrl = baseUrl;
		}
	}
</script>

<style scoped>
	.hello {
		width: 100%;
		height: 100vh;
		background: url("../assets/background.png") center center no-repeat;
		background-size: cover;
	}
	
	.tips {
		width: 100%;
		position: fixed;
		top: 0;
		left: 0;
		background: rgba(0, 0, 0, 0.5);
		text-align: center;
		color: white;
		font-size: 14px;
		line-height: 30px;
	}
	
	.logo {
		width: 58%;
		margin: 0 auto;
		padding-top: 20%;
	}
	
	.logo img {
		width: 100%;
	}
	
	.option {
		width: 78%;
		height: 50px;
		background: url("../assets/logo_bj.png") center center no-repeat;
		background-size: 100% 100%;
		display: flex;
		margin: 0 auto;
		padding: 4%;
		align-items: center;
	}
	
	.option_img_one {
		width: 35px;
	}
	
	.option_img_two {
		width: 45px;
		display: block;
	}
	
	.reservation_mode {
		font-size: 18px;
		font-family: PingFangSC-Medium;
		font-weight: 600;
		color: rgba(45, 45, 45, 1);
		line-height: 38px;
	}
	
	.logo_time {
		width: 100%;
		font-size: 12px;
		font-family: PingFangSC-Regular;
		font-weight: 400;
		color: rgba(121, 121, 121, 1);
		line-height: 24px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	
	.option_ts {
		margin-top: 10px;
	}
	
	.logo_option {
		width: 75%;
		margin: 50px auto;
		background: url(../assets/landbg.png) center center no-repeat;
		background-size: 100% 100%;
		padding: 0 5% 40px;
	}
	
	.logo_option p {
		width: 35%;
		color: #CD281D;
		line-height: 70px;
		font-size: 16px;
		text-align: center;
		margin-bottom: 15px;
	}
	
	.logo_option input {
		border: none;
		background: white;
		width: 88%;
		line-height: 35px;
		color: #393939;
		padding-left: 3%;
		outline: none;
		font-size: 14px;
	}
	
	.land_btn {
		width: 75%;
		background: #B40000;
		border-radius: 25px;
		color: rgba(255, 255, 255, 1);
		font-size: 14px;
		text-align: center;
		margin: 25px auto 0;
		line-height: 38px;
	}
	
	.land_text {
		width: 85%;
		margin: 0 auto;
		display: flex;
		justify-content: space-between;
	}
	
	.land_text div {
		text-align: center;
		color: #666;
		font-size: 14px;
		opacity: 0.65;
		margin-top: 20px;
	}
	
	.appointment_success {
		width: 110%;
		height: 100%;
		background: rgba(0, 0, 0, 0.54);
		position: fixed;
		top: 0;
		left: 0;
	}
	
	.success_center {
		margin-top: 35%;
		background: white;
		width: 60%;
		margin-left: 15%;
		padding-top: 10px;
		border-radius: 10px;
	}
	
	.success_center img {
		width: 25%;
		margin-left: 37%;
		margin-top: 30px;
	}
	
	.success_center p:nth-of-type(1) {
		width: 100%;
		color: black;
		font-size: 20px;
		font-weight: 600;
		text-align: center;
		margin-top: 20px;
	}
	
	.success_center p:nth-of-type(2) {
		width: 100%;
		color: #A4A4A4;
		font-size: 16px;
		text-align: center;
		margin-top: 5px;
		letter-spacing: 1px;
	}
	
	.success_center div {
		width: 100%;
		line-height: 45px;
		text-align: center;
		font-weight: 600;
		color: rgba(228, 4, 4, 1);
		border-top: 1px solid #eee;
		margin-top: 25px;
	}
	
	.IDNumber {
		width: 87%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		border-bottom: 1px solid rgba(218, 218, 218, 1);
		margin: 0 auto;
	}
	
	.IDNumber img {
		width: 8%;
	}
	
	.password {
		width: 87%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		border-bottom: 1px solid rgba(218, 218, 218, 1);
		margin: 0 auto;
	}
	
	.password img {
		width: 8%;
	}
</style>


// WEBPACK FOOTER //
// src/components/land.vue